import { useRoute } from "vue-router";
import { QueryStringDataBuilder } from "@/core/QueryString/QueryStringDataBuilder";
import { BlobConfigDataBuilder } from "../../service/blobConfig/BlobConfigDataBuilder";
import ConfigManager from "@/config/ConfigManager";
import BzbsApiLegacy from "@/core/Http/BzbsApiLegacy"
import Utility from "@/helper/Utility";
import BlobService from "@/core/Blob/service/BlobService";
import BzbsAuth from "@/core/Account/service/BzbsAuth";
import { ErrorType } from "@/helper/ErrorType.js";

/**
 * 
 * @param {import("@vue/reactivity").UnwrapRef<import("@/types/LandingFlow.d").LandingFlowStates>} states 
 * @param {*} localeStore 
 * @returns 
 */
export default function (states, localeStore) {
    const route = useRoute()

    /**
     *
     * @returns {Promise}
     */
    const loadConfig = function () {
        // load config from url query string
        /**
         * if legacy mode (old url that attach token)
         * then initialConfig as usual
         * but if modern mode then get payload from settings api first
         */
        let queryString = new QueryStringDataBuilder()
        states.query = queryString.setWithQuery(route.query).create();
        if (!Utility.isEmptyStr(states.query.accessKey)) {
            if (states.query.hasCache()) {
                // มี access key มา และมาจากหน้า bitkub callback (กรณีวิ่งไปข้างล็อกอิน bitkub มา ด้วยโฟลวแบบ access key)
                // ให้ดึงค่าจาก cache แทน
                states.query.loadCache()
                return initialConfig()
            } else {
                // มาจากเว็บหลักจะมีแค่ access key 
                // ให้ไปโหลด payload มาก่อน แล้วค่อย load config อื่นๆต่อ
                return loadPayload(states.query.accessKey).then(() => {
                    return initialConfig()
                })
            }
        } else {
            return initialConfig()
        }
    }

    const initialConfig = function () {
        if (states.query.theme) {
            states.blobUrl = `${ConfigManager.getBlobUrl()}/config/transferpoint/${states.mainAppName}/${states.query.theme}`;
        }
        return Promise.all([getAppConfig(), getBlobApiConfig()]).then((results) => {
            return results
        })
    }

    const getBlobApiConfig = function () {
        return new Promise((resolve, reject) => {
            let app_id = "";
            var version = states.query.version;
            if (version == 2) { 
                // หาชื่อไฟล์จาก app_id 
                app_id = states.query.appId;
                var blob_path = Utility.getUrlBlobJsonFromTheme(app_id, version);
                if (!blob_path) {
                    // พาไป error 
                    states.error_code = ErrorType.AppMapping
                    reject({
                        error_code: ErrorType.AppMapping
                    });
                    return;
                } 
                // get landing blob config
                BzbsApiLegacy.getBlobWeblandingConfigByBlobPath(blob_path).then((res_config) => {
                    states.blobWebLanding = res_config
                    resolve(states.blobWebLanding) 
                }).catch((err) => {
                    console.log(err)
                    states.blobWebLanding = null
                    reject(err)
                });
            }
            else {
                // theme mapping
                // version 1
                BzbsApiLegacy.getBlobAppThemeMapping().then((app_mapping) => {   
                    app_id = Utility.getAppIdFromTheme(app_mapping, states.query.theme);
                    //console.log(app_id, ErrorType.AppMapping);
                    var blob_path = Utility.getUrlBlobJsonFromTheme(app_id, version); 
                    // get landing blob config
                    BzbsApiLegacy.getBlobWeblandingConfigByBlobPath(blob_path).then((res_config) => {
                        states.blobWebLanding = res_config
                        resolve(states.blobWebLanding) 
                    }).catch((err) => {
                        console.log(err)
                        states.blobWebLanding = null
                        reject(err)
                    });
                }).catch((err) => {
                    console.log(err)
                    states.blobWebLanding = null
                    reject(err)
                });
            }
        })
    }

    const getAppConfig = function () {
        return new Promise((resolve, reject) => {
            BlobService.apiGetConfig(
                `${states.blobUrl}/config`,
                "config.json"
            )
                .then((res) => {
                    // console.log('res', res)
                    if (res && res.default) {
                        states.appConfig = new BlobConfigDataBuilder()
                            .setWithBlob(
                                res.default,
                                states.blobUrl,
                                localeStore.localeCode.value
                            )
                            .create();
                        // done
                        resolve(states.appConfig);
                        // console.log(states.appConfig)
                    } else {
                        resolve(null)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err)
                });
        })
    }

    const loadPayload = function (accKey) {
        return new Promise((resolve, reject) => {
            // console.log(states)
            BzbsAuth.apiReadAccessKey(accKey).subscribe({
                next: (res) => {
                    // console.log(res.data)
                    // update query model by payload then the flow go as usual
                    let queryString = new QueryStringDataBuilder()
                    states.query = queryString.setWithQuery(res.data, true).create()
                    states.query.accessKey = accKey // update access token
                    resolve(res.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    return {
        loadConfig,
        getBlobApiConfig,
        loadPayload
    }
}
